import { useContext } from 'react';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { QueryWithViewMode } from 'src/utils/eventQueryUtils';
import { Feature } from 'src/WebApiController';
import { useContextSelector } from 'use-context-selector';

import {
  createFilterQueryContext,
  createFilterQueryContextWithSelector,
  IFilterQueryContext,
} from './FilterQueryContext';

const useContextValueSelector = <T, TQuery extends QueryWithViewMode>(
  selector: (context: IFilterQueryContext<TQuery>) => T
): T => {
  const hasCatalogDataContextWithSelectorFeature = useUserHasFeature(
    Feature.FEPerf_CatalogDataContextWithSelector
  );
  const contextValue = useContextSelector(
    createFilterQueryContextWithSelector<TQuery>(),
    selector
  );
  const context = useContext(createFilterQueryContext<TQuery>());

  return hasCatalogDataContextWithSelectorFeature
    ? contextValue
    : selector(context);
};

export const useFilterQueryContextFilterQuerySelector = <
  T extends QueryWithViewMode,
>(): [T, (query: T) => void] => {
  const filterQuery = useContextValueSelector(
    (context) => context.filterQuery as T
  );
  const setFilterQuery = useContextValueSelector(
    (context) => context.setFilterQuery
  );
  return [filterQuery, setFilterQuery] as const;
};

export const useFilterQueryContextIsQueryInitializedSelector = (): boolean => {
  return useContextValueSelector((context) => context.isQueryInitialized);
};
